export const CONSTANT = {
	inspectOptions: {
		colors: true,
		depth: Infinity,
		maxArrayLength: Infinity
	}
};
